import { render, staticRenderFns } from "./assetTrends.vue?vue&type=template&id=168149f0&scoped=true"
import script from "./assetTrends.vue?vue&type=script&lang=js"
export * from "./assetTrends.vue?vue&type=script&lang=js"
import style0 from "./assetTrends.vue?vue&type=style&index=0&id=168149f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168149f0",
  null
  
)

export default component.exports